import { TGetDefaultInfoUnitResponse, TPayloadUpdateSuccess } from '@/services';
import { mergeItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { formatDefaultInfoUnitDetail, RootState } from '..';
import {
	TDefaultInfoUnitDetailStore,
	TPayloadGetDefaultInfoUnitDetailRequest,
	TPayloadGetDefaultInfoUnitDetailSuccess,
} from './fm1-01-default-info-unit.type';

const initialState = {
	fetching: false,
	defaultInfoUnitDetail: {} as TDefaultInfoUnitDetailStore,
};

const fm1_01DefaultInfoUnitSlice = createSlice({
	initialState,
	name: 'fm1_01DefaultInfoUnit',
	reducers: {
		/**---- GET FM1_01_DEFAULT_INFO_UNIT DETAIL START ---- */
		getDefaultInfoUnitDetailRequest: (
			state,
			action: PayloadAction<TPayloadGetDefaultInfoUnitDetailRequest>
		) => {
			state.fetching = true;
		},
		getDefaultInfoUnitDetailSuccess: (
			state,
			action: PayloadAction<TPayloadGetDefaultInfoUnitDetailSuccess>
		) => {
			const { defaultInfoUnitDetail } = action.payload;
			state.fetching = false;
			state.defaultInfoUnitDetail = defaultInfoUnitDetail;
		},
		getDefaultInfoUnitDetailFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET FM1_01_DEFAULT_INFO_UNIT DETAIL END ---- */

		/** UPDATE FM1_01_DEFAULT_INFO_UNIT DETAIL START */
		updateDefaultInfoUnitSuccess: (
			state,
			action: PayloadAction<TPayloadUpdateSuccess<TGetDefaultInfoUnitResponse>>
		) => {
			const { data } = action.payload;
			const defaultInfoUnitDetail = { ...state.defaultInfoUnitDetail };
			state.defaultInfoUnitDetail = formatDefaultInfoUnitDetail(
				mergeItemUpdated<
					TDefaultInfoUnitDetailStore,
					TGetDefaultInfoUnitResponse
				>(defaultInfoUnitDetail, data)
			);
		},
		/** UPDATE FM1_01_DEFAULT_INFO_UNIT DETAIL END */
	},
});

export const Fm1_01DefaultInfoUnitSelectors = {
	selectFetching: (state: RootState) => state.fm1_01DefaultInfoUnit.fetching,
	selectDefaultInfoUnitDetail: (state: RootState) =>
		state.fm1_01DefaultInfoUnit.defaultInfoUnitDetail,
};

export const Fm1_01DefaultInfoUnitActions = fm1_01DefaultInfoUnitSlice.actions;
export const Fm1_01DefaultInfoUnitReducer = fm1_01DefaultInfoUnitSlice.reducer;
